/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { EnEventStatus } from './en-event-status';
import { EnEventType } from './en-event-type';
import { EventExerciseDto } from './event-exercise-dto';
import { JoinEntityDto } from './join-entity-dto';
import { ProfileDto } from './profile-dto';
 /**
 *
 *
 * @export
 * @interface SessionEventDto
 */
export interface SessionEventDto {

    /**
     * Unique identifier
     *
     * @type {number}
     * @memberof SessionEventDto
     * @example 1
     */
    id: number;

    /**
     * Creation timestamp (ISO 8601)
     *
     * @type {string}
     * @memberof SessionEventDto
     * @example 2024-01-15T10:30:00.000Z
     */
    created: string;

    /**
     * Last update timestamp (ISO 8601)
     *
     * @type {string}
     * @memberof SessionEventDto
     * @example 2024-06-01T08:00:00.000Z
     */
    updated: string;

    /**
     * Soft-delete timestamp — null when the record is active
     *
     * @type {string}
     * @memberof SessionEventDto
     */
    deleted: string | null;

    /**
     * @type {EnEventType}
     * @memberof SessionEventDto
     */
    type: EnEventType;

    /**
     * @type {string}
     * @memberof SessionEventDto
     */
    title: string;

    /**
     * @type {Date}
     * @memberof SessionEventDto
     */
    start: Date;

    /**
     * @type {Date}
     * @memberof SessionEventDto
     */
    end?: Date | null;

    /**
     * @type {boolean}
     * @memberof SessionEventDto
     */
    allDay: boolean;

    /**
     * @type {boolean}
     * @memberof SessionEventDto
     */
    editable?: boolean | null;

    /**
     * @type {string}
     * @memberof SessionEventDto
     */
    groupId?: string | null;

    /**
     * @type {string}
     * @memberof SessionEventDto
     */
    note?: string | null;

    /**
     * Total expected duration of the event in seconds
     *
     * @type {number}
     * @memberof SessionEventDto
     */
    duration: number;

    /**
     * @type {string}
     * @memberof SessionEventDto
     */
    startedAt: string | null;

    /**
     * @type {string}
     * @memberof SessionEventDto
     */
    endedAt: string | null;

    /**
     * @type {EnEventStatus}
     * @memberof SessionEventDto
     */
    status: EnEventStatus;

    /**
     * @type {number}
     * @memberof SessionEventDto
     */
    weekIndex: number;

    /**
     * @type {boolean}
     * @memberof SessionEventDto
     */
    isFirst: boolean;

    /**
     * @type {boolean}
     * @memberof SessionEventDto
     */
    isLast: boolean;

    /**
     * @type {boolean}
     * @memberof SessionEventDto
     */
    isPrev: boolean;

    /**
     * @type {boolean}
     * @memberof SessionEventDto
     */
    isCurrent: boolean;

    /**
     * @type {boolean}
     * @memberof SessionEventDto
     */
    isNext: boolean;

    /**
     * Rounds the patient performs
     *
     * @type {number}
     * @memberof SessionEventDto
     */
    laps: number;

    /**
     * Rest between rounds, seconds
     *
     * @type {number}
     * @memberof SessionEventDto
     */
    rest: number;

    /**
     * @type {Array<EventExerciseDto>}
     * @memberof SessionEventDto
     */
    exercises: Array<EventExerciseDto>;

    /**
     * @type {JoinEntityDto}
     * @memberof SessionEventDto
     */
    session: JoinEntityDto | null;

    /**
     * @type {JoinEntityDto}
     * @memberof SessionEventDto
     */
    assignment: JoinEntityDto;

    /**
     * @type {ProfileDto}
     * @memberof SessionEventDto
     */
    user: ProfileDto;

    /**
     * @type {JoinEntityDto}
     * @memberof SessionEventDto
     */
    operator: JoinEntityDto | null;

    /**
     * @type {JoinEntityDto}
     * @memberof SessionEventDto
     */
    rescheduled: JoinEntityDto | null;
}
